import { Inject, Injectable } from '@angular/core';
import { CORE_API_ROUTES } from '@app/core/configs/api-routes';
import { HttpService } from '@app/core/services/http.service';
import { Observable } from 'rxjs';
import { BuiltInRoleType, IRole } from '../models/role';

@Injectable()
export class RoleService {
  constructor(@Inject(CORE_API_ROUTES) private apis, private httpService: HttpService) {}

  getAllRoles$(): Observable<IRole[]> {
    return this.httpService.get<IRole[]>(this.apis.role.roles);
  }

  getRole$(roleId: BuiltInRoleType | string): Observable<IRole> {
    return this.httpService.get<IRole>(this.apis.role.id(roleId));
  }

  addRole$(role: IRole): Observable<IRole> {
    return this.httpService.put<IRole, IRole>(this.apis.role.role, role);
  }

  updateRole$(roleId: BuiltInRoleType | string, updatedRole: Partial<IRole>): Observable<IRole> {
    return this.httpService.patch<IRole, Partial<IRole>>(this.apis.role.role, updatedRole);
  }

  deleteRole$(roleId: BuiltInRoleType | string): Observable<boolean> {
    return this.httpService.delete<boolean>(this.apis.role.id(roleId));
  }
}
